/* eslint-disable @typescript-eslint/no-unused-vars */
// TODO: Do these need to be imported for the typing to work correctly?
import type { ButtonPropsColorOverrides } from '@mui/material/Button';
import type { FabPropsColorOverrides } from '@mui/material/Fab';
import type { Theme, ThemeOptions } from '@mui/material/styles';
import type {
  ColumnsManagementPropsOverrides,
  GridColumnVisibilityModel,
} from '@mui/x-data-grid';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    promo: true;
  }
}

declare module '@mui/material/Fab' {
  interface FabPropsColorOverrides {
    promo: true;
  }
}

declare module '@mui/x-data-grid' {
  interface ColumnsManagementPropsOverrides {
    /**
     * The columns will reset to the original defaults when reset button is clicked
     * This is useful when saving columns visibility to localStorage and needing a way to reset to original defaults
     */
    defaultColumnVisibilityModel?: GridColumnVisibilityModel;
    /**
     * The maximum number of columns that can be selected before other toggles are disabled.
     */
    max?: number;
  }
}

declare module '@mui/material/styles' {
  interface Theme {
    maxWidth: { paragraph: string };
  }

  interface ThemeOptions {
    maxWidth?: {
      paragraph?: string;
    };
  }
}

export const maxWidth = {
  paragraph: '65ch',
};
